import React, { useEffect, useState, useRef } from 'react';
import axiosInstance from '../../axiosInstance';
import UpdateAvatarLogo from './UpdateAvatarLogo';
import AddProfessionals from './AddProfessionals';
import axios from 'axios';
import Select from 'react-select';
import { toast } from 'react-toastify';

function HomeOwnerConceirge() {
  const [vendorUserOptions, setVenderUserOptions] = useState([
    // { name: "Test", id: "f65c0913-9387-4339-89ec-0d868f8f0d75" },
    // { name: "Amy Stockberger", id: "d7711f63-43a4-448f-b47a-1009dd6808b8" },
    // { name: "Justin Stoddart", id: "88da7daa-d5f6-45b8-957f-e32174d7e086" },
    // { name: "Joelle Lewis", id: "d3ef11fa-ff65-45d2-bd93-9a3e49c0b210" },
    // { name: "Brad Eaton", id: "16cc55fc-2729-4b85-8c03-dab985429558" },
    // { name: "Rick Brainard", id: "aadeaf00-a035-46ac-bfa3-c89bd4362d4c" },
    // { name: "Scott Jensen", id: "224e94d6-61af-4d15-8996-f6e98f396b1c" },
    // { name: "Justin Bosak", id: "7822a237-4c53-4820-b719-55ec0f67baea" },
    // { name: "Peggy Williams", id: "c1f7c37e-446b-4f52-8d86-97084624ddf3" },
    // { name: "Johnny Jenning", id: "022ddc67-ad73-4188-bb2c-558d61a2be64" },
    // { name: "Russell Enyart", id: "9f993038-9d09-40fb-81c7-1f63d5ccfffa" },
    // { name: "Noelle McAdams", id: "64d9597d-4a03-4e96-aaa2-5bb30b612d37" },
    // { name: "Jay Peet", id: "76269180-751e-4ba9-9b3b-b175726289b1" },
    // { name: "Ric Prete", id: "438dbe77-c182-4b14-a20e-9e4e0d5f7a1e" },
    // { name: "Sabrina Shaw", id: "0c9b825a-6e3d-4255-9839-2b7b70f2e6a8" },
    // { name: "Tony Tramontozzi", id: "9b3c12d6-751a-4dd3-96fa-a90f0450649c" },
  ]);

  const [selectedVendor, setSelectedVendor] = useState("");
  const [cardsData, setCardsData] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingCards, setIsLoadingCards] = useState(false);

  const [editCard, setEditCard] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [company, setCompany] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");

  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // New states for Add Professional modal
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [contactSearchTerm, setContactSearchTerm] = useState('');
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const fileInputRef = useRef(null);
  const [uploadingExcel, setUploadingExcel] = useState(false);

  // For cancelling previous get_card_details requests
  const abortControllerRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem('authTokens');
    window.location.href = "/login";
  };

  const getCardsDetails = async (vendorId, loadCards = true) => {
    // Cancel any previous ongoing request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new AbortController for this request
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsLoadingCards(loadCards);
    setError('');
    setMessage("");

    try {
      const response = await axiosInstance.post(
        '/get_card_details',
        { user_id: vendorId },
        {
          signal: controller.signal,
          headers: {}
        }
      );

      const data = response.data || [];
      setCardsData(data);
      setFilteredCards(data);
    } catch (err) {
      // Ignore errors from cancelled requests
      if (err.name === 'CanceledError' || axios.isCancel(err)) {
        return;
      }

      console.error(err);
      setError('Failed to load vendor information.');
      setCardsData([]);
      setFilteredCards([]);
    } finally {
      // Only clear loading state if this is still the active request
      if (abortControllerRef.current === controller) {
        setIsLoadingCards(false);
        abortControllerRef.current = null;
      }
    }
  };

  const getContacts = async () => {
    setError('');
    try {
      const response = await axiosInstance.get('/get_contacts');
      const data = response.data || [];
      setContacts(data);
      let updatedData = data
        .filter(user => user.first_name && user.last_name)   // both must be truthy
        .map(user => ({
          id: user.user_id,
          name: `${user.first_name} ${user.last_name}`
        }));
      setVenderUserOptions(updatedData)
    } catch (err) {
      console.error(err);
      setError('Failed to load contacts.');
      setContacts([]);
    }
  };

  // Filter cards whenever searchTerm or cardsData changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredCards(cardsData);
      return;
    }

    const term = searchTerm.toLowerCase().trim();

    const filtered = cardsData.filter(card => {
      const name = (card.fullname || '').toLowerCase();
      const business = (card.business || '').toLowerCase();
      const email = (card.email || '').toLowerCase();
      const profession = (card.profession || '').toLowerCase();

      return (
        name.includes(term) ||
        business.includes(term) ||
        email.includes(term) ||
        profession.includes(term)
      );
    });

    setFilteredCards(filtered);
  }, [searchTerm, cardsData]);

  // Load cards when selectedVendor changes
  useEffect(() => {
    if (selectedVendor && selectedVendor !== "none") {
      getCardsDetails(selectedVendor);
    } else {
      // Cancel any pending request when deselecting
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
        abortControllerRef.current = null;
      }
      setCardsData([]);
      setFilteredCards([]);
      setSearchTerm("");
    }

    // Cleanup: cancel on unmount or next vendor change
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [selectedVendor]);

  useEffect(() => {
    getContacts();
  }, []);

  // Set initial values when edit modal opens
  useEffect(() => {
    if (editCard) {
      setCompany(editCard.business || "");
      setWebsiteUrl(editCard.website_url || "");
      setAvatarPreview(editCard.avatar || null);
      setLogoPreview(editCard.logo || null);
      setAvatarFile(null);
      setLogoFile(null);
    }
  }, [editCard]);

  // File handlers
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith('image/')) return;
    setAvatarFile(file);
    setAvatarPreview(URL.createObjectURL(file));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith('image/')) return;
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  const uploadImage = async (file, mediaType) => {
    if (!file || !editCard) return false;

    const MAX_SIZE = 5 * 1024 * 1024;

    if (file.size > MAX_SIZE) {
      setError('File size should not exceed 5MB.');
      return false;
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('userId', editCard.id);
    formData.append('mediaType', mediaType);
    formData.append('profile_userid', selectedVendor);

    try {
      await axiosInstance.post(
        '/update_avatar',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return true;
    } catch (err) {
      // console.error(err);
      const errorMessage = err?.response?.data?.error || `Failed to upload ${mediaType}.`;
      // console.log("errorMessage", errorMessage);
      setError(errorMessage);
      return false;
    }
  };

  const updateCompanyDetails = async () => {
    if (!editCard?.id) return false;

    const payload = {
      user_id: editCard.id,
      company: company.trim(),
      website_url: websiteUrl.trim(),
      profile_userid: selectedVendor
    };

    try {
      await axiosInstance.post('/update_web', payload);
      return true;
    } catch (err) {
      console.error(err);
      const errorMessage = err?.response?.data?.error || `Failed to update company/website.`;
      setError(errorMessage);
      return false;
    }
  };

  const handleSaveEdits = async () => {
    setUploading(true);
    setMessage('');
    setError('');

    let success = true;

    // Update company & website if they changed
    if (company.trim() !== (editCard.business || '').trim() ||
      websiteUrl.trim() !== (editCard.website_url || '').trim()) {
      success = await updateCompanyDetails();
      if (!success) {
        setUploading(false);
        return;
      }
    }

    if (avatarFile) {
      success = await uploadImage(avatarFile, 'avatar');
      if (!success) {
        setUploading(false);
        return;
      }
    }

    if (logoFile) {
      success = await uploadImage(logoFile, 'logo');
      if (!success) {
        setUploading(false);
        return;
      }
    }

    if (success) {
      setMessage('Update successful!');
      getCardsDetails(selectedVendor, false);
      closeModal();
    }

    setUploading(false);
  };

  const closeModal = () => {
    setEditCard(null);
    setAvatarFile(null);
    setAvatarPreview(null);
    setLogoFile(null);
    setLogoPreview(null);
    setCompany("");
    setWebsiteUrl("");
    setMessage('');
    setError('');
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
  };

  // Add Professional Handlers
  const openAddModal = () => {
    setAddModalOpen(true);
    setSelectedContactIds([]);
    setContactSearchTerm('');
    setMessage('');
    setError('');
  };

  const closeAddModal = () => {
    setAddModalOpen(false);
  };

  const toggleContactSelect = (contactId) => {
    setSelectedContactIds(prev =>
      prev.includes(contactId)
        ? prev.filter(id => id !== contactId)
        : [...prev, contactId]
    );
  };

  const handleAddProfessionals = async () => {
    if (selectedContactIds.length === 0) {
      setError('Please select at least one contact.');
      return;
    }

    setError('');
    setMessage('');

    try {
      await axiosInstance.post(
        '/communityledger',
        {
          selector: "addpeople",
          communityid: selectedVendor,
          peopleids: selectedContactIds
        }
      );

      setMessage('Professionals added successfully!');
      getCardsDetails(selectedVendor, false);
      closeAddModal();
    } catch (err) {
      console.error(err);
      const errorMessage = err?.response?.data?.error || `Failed to add professionals.`;
      setError(errorMessage);
    }
  };

  const existingCardIds = new Set(cardsData.map(card => card.id));
  const filteredContacts = contacts.filter(contact => {
    const term = contactSearchTerm.toLowerCase();
    const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.toLowerCase();
    const email = (contact.email || '').toLowerCase();

    return !existingCardIds.has(contact.user_id) && (
      fullName.includes(term) || email.includes(term)
    );
  });

  const handleRemoveProfessional = async (data) => {
    const confirmed = window.confirm(`Please confirm to remove this professional "${data.fullname}"`);
    if (confirmed) {
      try {
        await axiosInstance.post(
          '/communityledger',
          {
            selector: "removepeople",
            communityid: selectedVendor,
            peopleids: [data.id]
          }
        );

        setMessage('Professionals removed successfully!');
        getCardsDetails(selectedVendor, false);
      } catch (err) {
        console.error(err);
        const errorMessage = err?.response?.data?.error || `Failed to remove professionals.`;
        setError(errorMessage);
      }
    }
  };

  const handleUploadClick = () => {
    if (!selectedVendor || selectedVendor === "none") {
      setError("Please select a community before uploading.");
      return;
    }

    fileInputRef.current.click();
  };

  const handleExcelFileChange = async (e) => {
    const input = e.target;
    const file = input.files[0];
    if (!file) return;

    const allowedTypes = ["text/csv", "application/csv", "application/vnd.ms-excel"];

    if (!allowedTypes.includes(file.type) && !file.name.toLowerCase().endsWith(".csv")) {
      setError("Please upload a valid CSV file (.csv)");
      return;
    }

    setUploadingExcel(true);
    setError("");
    setMessage("");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", selectedVendor);

    try {
      const response = await axiosInstance.post("/seed_profile", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const {
        created = 0,
        failed_count = 0,
        profile_added = 0,
        failed_users,
      } = response.data || {};

      const failedUsers = Array.isArray(failed_users) ? failed_users : [];

      // Success message
      if (created > 0) {
        toast.success(`Successfully added ${created} user${created === 1 ? "" : "s"}`);
      }

      if (profile_added > 0) {
        toast.success(`Profiles added under this profile: ${profile_added}`);
      }

      // Failed users with detailed errors
      if (failed_count > 0 && failedUsers.length > 0) {

        const errorLines = failedUsers.map((fail) => {

          const email = fail?.email || "Unknown email";
          let errorMsg = String(fail?.error || "Unknown error");

          if (errorMsg.includes("Seed API failed:")) {
            try {
              const innerMatch = errorMsg.match(/Seed API failed: (\{.*\})/);

              if (innerMatch && innerMatch[1]) {
                const inner = JSON.parse(innerMatch[1]);
                errorMsg = inner?.errormessage || inner?.error || "Unknown error";
              }
            } catch (e) {
              // ignore parsing errors
            }
          }

          // Remove repeated email text if present
          errorMsg = errorMsg.replace(/email '.*?'/g, "email");

          return `• ${email} — ${errorMsg.trim()}`;
        });

        const title = `Failed to upload ${failed_count} user${failed_count === 1 ? "" : "s"}`;

        toast.error(
          `${title}:\n${errorLines.join("\n")}`,
          {
            autoClose: 12000,
            closeOnClick: false,
            style: { whiteSpace: "pre-line" }
          }
        );
      }

      // Refresh list
      getCardsDetails(selectedVendor, false);

    } catch (err) {
      console.error(err);
      toast.error("Failed to upload CSV file. Please try again.");
      setError("Failed to upload CSV file.");
    } finally {
      setUploadingExcel(false);
      if (input) input.value = null; // reset file input safely
    }
  };

  return (
    <div className='homeOwnerConceirgeDiv' style={{ padding: '10px 32px', margin: '0 auto' }}>

      {/* Logout */}
      <div style={{ textAlign: "end" }}>
        <button
          className="logout-btn"
          onClick={handleLogout}
          style={{ border: "1px solid red", padding: ".5rem 3rem", color: "red", borderRadius: "10px", marginBottom: "5px" }}
        >
          Logout
        </button>
      </div>

      {/* Vendor Selector + Search */}
      <div >
        <div style={{ marginBottom: '40px', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '16px' }}>
          {/* <select
            value={selectedVendor}
            onChange={(e) => setSelectedVendor(e.target.value)}
            style={{
              height: '57px',
              padding: '0 16px',
              fontSize: '16px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              width: '300px',
            }}
          >
            <option style={{ fontSize: "16px", color: "grey" }} disabled={selectedVendor} value="none">Select Community</option>
            {vendorUserOptions.map((user) => (
              <option style={{ fontSize: "16px" }} key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select> */}

          <Select
            options={vendorUserOptions.map(v => ({ value: v.id, label: v.name }))}
            value={
              selectedVendor
                ? vendorUserOptions.find(v => v.id === selectedVendor)
                  ? { value: selectedVendor, label: vendorUserOptions.find(v => v.id === selectedVendor).name }
                  : null
                : null
            }
            onChange={(option) => setSelectedVendor(option ? option.value : "none")}
            placeholder="Select Community"
            isSearchable
            // isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '57px',
                minHeight: '57px',
                borderRadius: '6px',
                borderColor: '#ccc',
                fontSize: '16px',
                minWidth: "210px",
                maxWidth: "280px"
              }),
              valueContainer: (base) => ({
                ...base,
                padding: '0 16px',
              }),
            }}
          />

          {selectedVendor && selectedVendor !== "none" && (
            <input
              placeholder="Search by name, business or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                height: '57px',
                padding: '0 16px',
                fontSize: '16px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                width: '300px',
                color: "white"
              }}
            />
          )}
          {selectedVendor && selectedVendor !== "none" && (
            <div>
              <button
                onClick={openAddModal}
                style={{
                  height: '57px',
                  padding: '0 24px',
                  fontSize: '16px',
                  background: '#1976d2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  marginTop: "1px",
                }}
              >
                Add Professionals
              </button>
              <input
                type="file"
                // accept=".xlsx,.xls"
                accept=".csv,text/csv"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleExcelFileChange}
              />
              <button
                onClick={handleUploadClick}
                disabled={uploadingExcel}
                style={{
                  marginLeft: "10px",
                  height: '57px',
                  padding: '0 24px',
                  background: '#1976d2',
                  color: 'white',
                  border: 'none',
                  marginTop: "1px",
                  borderRadius: '6px'
                }}
              >
                {uploadingExcel ? "Uploading..." : "Upload Sheet"}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Cards + Loading */}
      {isLoadingCards ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '80px 0',
          fontSize: '18px',
          color: '#777',
          gap: '12px',
        }}>
          <div style={{
            width: '28px',
            height: '28px',
            border: '4px solid #e0e0e0',
            borderTop: '4px solid #1976d2',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }} />
          <span>Loading...</span>
        </div>
      ) : filteredCards.length > 0 ? (
        <div
          style={{
            display: 'flex',
            gap: '28px',
            paddingBottom: '48px',
            flexWrap: "wrap",
            justifyContent: "center"
          }}
        >
          {filteredCards.map((card, index) => {
            const websiteUrl = card.website_url || "";
            const firstWebsite = websiteUrl.split(",")[0]?.trim() || "";

            return (
              <div
                key={index}
                className='cardContainer'
                style={{ position: 'relative' }}
              >
                <button
                  onClick={() => setEditCard(card)}
                  style={{
                    position: 'absolute',
                    top: '12px',
                    right: '50px',
                    background: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: '18px',
                    // zIndex: 2,
                  }}
                  title="Edit avatar / logo"
                >
                  ✏️
                </button>

                <button
                  onClick={() => handleRemoveProfessional(card)}
                  style={{
                    position: 'absolute',
                    top: '12px',
                    right: '12px',
                    background: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: '18px',
                    // zIndex: 2,
                  }}
                  title="Remove Professional"
                >
                  🗑️
                </button>

                {card.logo && (
                  <div style={{ marginBottom: '20px', display: "flex", justifyContent: "center" }}>
                    <a
                      href={firstWebsite}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ pointerEvents: firstWebsite ? 'auto' : 'none' }}
                    >
                      <img
                        src={card.logo}
                        alt="Company Logo"
                        style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }}
                      />
                    </a>
                  </div>
                )}

                <div style={{ display: "flex", justifyContent: "center", marginBottom: '20px' }}>
                  <img
                    src={card.avatar || "https://cdn-icons-png.flaticon.com/512/847/847969.png"}
                    alt={card.fullname || "User"}
                    style={{
                      width: '120px',
                      height: '120px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '3px solid #eee',
                      background: "grey"
                    }}
                  />
                </div>

                <h3 style={{ textAlign: 'center', marginBottom: '16px', fontSize: '18px', color: "black" }}>
                  {card.business || 'N/A'} {card.fullname ? `- ${card.fullname}` : ''}
                </h3>

                <hr style={{ margin: '16px 0', borderColor: '#eee' }} />

                {card.phone && (
                  <p style={{ textAlign: 'center', marginBottom: '12px', color: "black" }}>
                    <a
                      href={`tel:${card.phone}`}
                      style={{ color: '#1976d2', textDecoration: 'none' }}
                    >
                      {formatPhoneNumber(card.phone)}
                    </a>
                  </p>
                )}

                {card.email && (
                  <p style={{ textAlign: 'center', color: '#444' }}>
                    {card.email}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      ) : selectedVendor && selectedVendor !== "none" ? (
        <p style={{ color: '#777', fontSize: '18px', textAlign: 'center', marginTop: '40px' }}>
          {searchTerm
            ? "No matching professional found."
            : "No professional data found."}
        </p>
      ) : null}

      {/* Edit Modal */}
      {editCard && (
        <UpdateAvatarLogo
          closeModal={closeModal}
          editCard={editCard}
          avatarPreview={avatarPreview}
          avatarFile={avatarFile}
          logoPreview={logoPreview}
          logoFile={logoFile}
          uploading={uploading}
          handleAvatarChange={handleAvatarChange}
          handleLogoChange={handleLogoChange}
          setCompany={setCompany}
          company={company}
          setWebsiteUrl={setWebsiteUrl}
          websiteUrl={websiteUrl}
          message={message}
          error={error}
          handleSaveEdits={handleSaveEdits}
        />
      )}

      {/* Add Professional Modal */}
      {addModalOpen && (
        <AddProfessionals
          closeAddModal={closeAddModal}
          contactSearchTerm={contactSearchTerm}
          setContactSearchTerm={setContactSearchTerm}
          filteredContacts={filteredContacts}
          toggleContactSelect={toggleContactSelect}
          selectedContactIds={selectedContactIds}
          contacts={contacts}
          isAdding={isAdding}
          handleAddProfessionals={handleAddProfessionals}
          message={message}
          error={error}
        />
      )}
    </div>
  );
}

export default HomeOwnerConceirge;